/** URL query parameter names for marketing click IDs (ad attribution). */
export const MARKETING_CLICK_ID_PARAMS = [
  'gclid',
  'fbclid',
  'ttclid',
  'msclkid',
  'sccid',
  'dclid',
  'twclid',
  'li_fat_id',
] as const

export type MarketingClickIdParam = (typeof MARKETING_CLICK_ID_PARAMS)[number]

/** Map of marketing click ID param name to value (for event properties). */
export type MarketingClickIds = Partial<Record<MarketingClickIdParam, string>>

/**
 * Platform cookie fallbacks for click IDs (set by ad platform SDKs).
 * Key: URL param name; value: cookie name to read. gclid uses _gcl_aw and is parsed (see getGclidFromCookie).
 */
export const MARKETING_CLICK_ID_COOKIE_FALLBACK: Partial<
  Record<MarketingClickIdParam, string>
> = {
  gclid: '_gcl_aw',
  dclid: '_gcl_dc',
  ttclid: '_ttp',
  msclkid: '_uetmsclkid',
  li_fat_id: 'li_fat_id',
}

/** URL param aliases (e.g. Snapchat uses both sccid and ScCid). */
export const URL_PARAM_ALIASES: Partial<
  Record<MarketingClickIdParam, readonly string[]>
> = {
  sccid: ['sccid', 'ScCid'],
}

/** localStorage key for persisted marketing click IDs (30-day expiry). */
export const STORAGE_KEY_MARKETING_CLICK_IDS = 'suitsupply_marketing_click_ids'

/** How long persisted marketing click IDs are kept (days). */
export const MARKETING_CLICK_IDS_EXPIRY_DAYS = 30

export interface StoredMarketingClickIds {
  clickIds: MarketingClickIds
  expiresAt: number
}
